<div class="flex flex-col w-full">
    <span *ngIf="titulo" class="font-semibold mb-2">{{ titulo }}</span>

    <!-- Si no hay archivos nuevos ni guardados -->
    <div
        *ngIf="
            archivosGuardados.length === 0 &&
            selectedFiles.length === 0 &&
            soloLectura
        "
        class="text-gray-500 text-sm p-4 border border-dashed rounded-lg text-center"
    >
        {{ mensajeVacio }}
    </div>

    <!-- Botón seleccionar archivo -->
    <div class="flex items-center w-full mt-2" *ngIf="!soloLectura">
        <button
            mat-icon-button
            type="button"
            matTooltip="Añadir Adjunto"
            [ngStyle]="{
                'background-color': color_primario,
            }"
            class="transition duration-300 ease-in-out"
            (click)="fileInput.click()"
        >
            <mat-icon class="!text-white transform -rotate-45"
                >attach_file</mat-icon
            >
        </button>
        <input
            #fileInput
            type="file"
            [multiple]="maxArchivos > 1"
            [accept]="extensionesPermitidas.join(',')"
            (change)="onAddAdjunto($event)"
            hidden
        />
        <small
            class="text-gray-600 ml-4 cursor-pointer"
            (click)="fileInput.click()"
        >
            <strong>{{
                titleAdjunto ? "Agregar Archivos" : "Seleccione Archivo"
            }}</strong>
            (Máx: {{ maxSizeMb }} Mb)
        </small>
    </div>

    <!-- Archivos nuevos -->
    <div *ngIf="selectedFiles.length > 0" class="flex flex-col w-full mt-4 space-y-3">
        <div *ngIf="mostrarListaArchivos" class="flex items-center flex-wrap gap-2">
            <span class="text-[10px] font-black uppercase tracking-widest text-gray-400">Archivos seleccionados</span>
            <div
                *ngFor="let file of selectedFiles"
                [ngStyle]="{
                    'background-color': color_primario,
                    border: '1px solid ' + color_primario
                }"
                class="flex items-center justify-between px-3 py-1 rounded-full w-full max-w-xs shadow-sm shadow-black/10 cursor-pointer"
                (click)="openNuevoAdjunto(file)"
            >
                <span
                    matTooltip="{{ file.name }}"
                    class="truncate text-xs font-bold text-white flex-1"
                >
                    {{ file.name }}
                </span>
                <span class="text-[9px] text-white/70 mx-2 font-medium">{{ getFileSize(file.size) }}</span>
                <button
                    mat-icon-button
                    type="button"
                    (click)="removeFile('nuevo', file); $event.stopPropagation()"
                    matTooltip="Eliminar"
                    class="!w-6 !h-6 !min-h-6 !p-0"
                >
                    <mat-icon class="icon-size-4 text-white">close</mat-icon>
                </button>
            </div>
        </div>

        <!-- Preview de Imágenes -->
        <div class="flex flex-wrap gap-4 mt-2" *ngIf="mostrarPreview">
            <ng-container *ngFor="let adj of adjuntosNuevos">
                <div *ngIf="isImage(adj.extension)" 
                     class="relative w-32 h-32 rounded-xl border-2 border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 bg-white p-1">
                    
                    <!-- Imagen con click para zoom -->
                    <div class="w-full h-full rounded-lg overflow-hidden cursor-zoom-in" 
                         (click)="selectedPreview = getPreviewUrl(adj.base64, adj.extension)">
                        <img [src]="getPreviewUrl(adj.base64, adj.extension)" 
                             class="w-full h-full object-cover transition-transform duration-500 hover:scale-110">
                    </div>
                    
                    <!-- Botón eliminar en la esquina -->
                    <button mat-icon-button type="button" 
                            (click)="removeFile('nuevo', adj)" 
                            class="!absolute -top-2 -right-2 !w-7 !h-7 !min-h-7 !bg-red-500 !text-white shadow-md z-10 hover:!bg-red-600 transition-colors">
                        <mat-icon class="icon-size-4 !text-white">close</mat-icon>
                    </button>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Archivos guardados -->
    <div
        *ngIf="archivosGuardados.length > 0"
        class="flex flex-col w-full mt-4 space-y-3"
    >
        <span class="text-[10px] font-black uppercase tracking-widest text-gray-400">Archivos guardados</span>
        <div class="flex items-center flex-wrap gap-2">
            <div
                *ngFor="let adj of archivosGuardados"
                [ngStyle]="{
                    'background-color': color_primario,
                    border: '1px solid ' + color_primario
                }"
                class="flex items-center justify-between px-3 py-1 rounded-full w-full max-w-xs shadow-sm shadow-black/10 cursor-pointer"
                (click)="openAdjunto(adj)"
            >
                <span
                    class="truncate text-xs font-bold text-white flex-1"
                    [matTooltip]="adj.name"
                >
                    {{ adj.name }}
                </span>
                <button
                    mat-icon-button
                    type="button"
                    class="!w-6 !h-6 !min-h-6 !p-0 ml-auto"
                    (click)="openAdjunto(adj); $event.stopPropagation()"
                    matTooltip="Ver Archivo"
                >
                    <mat-icon class="icon-size-4 text-white">open_in_new</mat-icon>
                </button>
                <button
                    *ngIf="!soloLectura"
                    mat-icon-button
                    type="button"
                    (click)="removeFile('guardado', adj); $event.stopPropagation()"
                    matTooltip="Eliminar"
                    class="!w-6 !h-6 !min-h-6 !p-0"
                >
                    <mat-icon class="icon-size-4 text-white">close</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Popup / Visor de Imagen Fullscreen -->
<div *ngIf="selectedPreview" 
     class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 p-10 animate-in fade-in duration-200"
     (click)="selectedPreview = null">
    <div class="relative max-w-full max-h-full" (click)="$event.stopPropagation()">
        <img [src]="selectedPreview" class="rounded-lg shadow-2xl max-w-full max-h-[90vh] object-contain">
        <button mat-icon-button 
                class="absolute -top-12 right-0 !text-white !bg-white/10 hover:!bg-white/20 backdrop-blur-md" 
                (click)="selectedPreview = null">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
